<template>
  <div  class="table_component" tabindex="0">
    <div v-if="flagFourth == false" class="buttons">
      <button @click="retourSecond">Retour</button>
      <button @click="ouvrirModalFichier('fichier')">Téléverser fichier(s)</button>
      <button @click="ouvrirModalDossier('dossier')">Créer un dossier</button>
    </div>

    <table v-if="flagFourth == false">
      <thead>
        <tr>
          <th>Désignation / Référence</th>
          <th>Type</th>
          <th>Date</th>
          <th>Créateur / Créatrice</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in listeTableThird" :key="item._id">
          <td>{{ afficherNom(item.originalname) }}</td>
          <td>{{ afficherType(item) }}</td>
          <td>{{ formatDate(item.date) }}</td>
          <td>{{ item.prenom }} {{ item.nom }}</td>
          <td class="buttons">
            <button v-if="item.type === 'Dossier'" class="apercu" @click.stop="voir(item._id, item.originalname)">
              <i class="fa fa-arrow-right"></i> Aperçu
            </button>
            <button v-if="item.type === 'Fichier'" class="telecharger" @click.stop="download(item.filename, 'third')">
              <i class="fa fa-download"></i> Télécharger
            </button>
            <button v-if="item.email === email || domain === 'gthconsult.ma'" class="supprimer" @click.stop="confirmerSuppression(item)">
              <i class="fa fa-trash"></i> Supprimer
            </button>
          </td>
        </tr>
      </tbody>
    </table>
      <div v-if="isLoading">
        <p>Chargement : {{ uploadProgress }}%</p>
        <progress :value="uploadProgress" max="100"></progress>
      </div>
    <loading v-model:active="isLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="fullPage" />
    <Create v-if="flagCreate == true" :type="type" @closeConfirmation="closeConfirmation" @validerConfirmationDossier="ajouterDossier" @validerConfirmationFichier="ajouterFichier" />
    <TableFourth v-if="flagFourth == true" :idThird="idThird" :titreThird="titreThird" :email="email"
      @retourThird="retourThird" />
    <DeleteModel v-if="flagDeleteModel" :messageDelete="messageDelete" @validerDeleteModel="supprimerElement"
      @closeDeleteModel="flagDeleteModel = false" />
  </div>
</template>

<script>
import Create from "@/components/models/Transfer/Create.vue";
import DeleteModel from "@/components/models/DeleteModel.vue";
import TableFourth from "@/components/models/Transfer/TableFourth.vue";
import Espace from "@/connection/Espace";
import Loading from "vue-loading-overlay";

export default {
  name: "table_component",
  components: { Loading, Create, DeleteModel, TableFourth },
  props: { idSecond: String, titreParent: String, email: String },
  data() {
    return {
      idThird : null,
      titreThird : null,
      flagFourth : false,
      listeTableThird: [],
      domain: null,
      flagCreate: false,
      type: null,
      isLoading: false,
      uploadProgress : 0,
      flagDeleteModel: false,
      elementASupprimer: null,
      messageDelete: "Êtes-vous sûr de vouloir supprimer cet élément ?",
    };
  },
  methods: {

    ajouterDossier(name) {
      this.closeConfirmation();
      this.isLoading = true;
      Espace.soumetterThirdDossier(this.email, name, this.idSecond)
        .then(res => {
          this.listeTableThird.unshift(res.data);
          this.isLoading = false;
        })
        .catch(err => console.log(err));
    },


    async ajouterFichier(documents) {
            this.type = null;
            this.flagCreate = false;
            this.isLoading = true;
            this.uploadProgress = 0;

            try {
                const start = performance.now();

                const formData = new FormData();
                formData.append("email", this.email);
                formData.append("idSecond", this.idSecond);

                for (let i = 0; i < documents.length; i++) {
                    formData.append("fichier" + i, documents[i]);
                }

                const config = {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    this.uploadProgress = percentCompleted;
                    console.log("Progression upload :", percentCompleted + "%");
                },
                timeout: 0
                };

                const result = await Espace.soumetterThirdFichier(formData, config);

                if (result?.data?.length) {
                    for (const item of result.data) {
                        this.listeTableThird.unshift(item);
                    }
                }

                const end = performance.now();
                console.log(`Upload terminé en ${(end - start) / 1000} secondes`);

            } catch (error) {
                console.error("Erreur lors de l'upload :", error);
            } finally {
                this.isLoading = false;
                this.uploadProgress = 0;
            }
    },

    voir(id, name) {
        this.idThird = id;
        this.titreThird = name;
        this.flagFourth = true;
    },

    typeFichier(nom) {
      if (!nom.includes(".")) return "Dossier";
      const ext = nom.split(".").pop().toLowerCase();
      const map = {
        pdf: "Pdf", doc: "Word", docx: "Word", xls: "Excel", xlsx: "Excel",
        csv: "CSV", ppt: "PowerPoint", pptx: "PowerPoint", jpeg: "Image JPEG",
        jpg: "Image JPEG", png: "Image PNG", mp4: "Vidéo MP4", mp3: "Audio MP3",
        html: "Fichier HTML", css: "Fichier CSS", js: "Fichier JS",
        json: "Fichier JSON", xml: "Fichier XML",
      };
      return map[ext] || "Fichier";
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    afficherNom(nom) {
      return nom.length > 60 ? nom.substr(0, 30) + "..." : nom;
    },
    afficherType(item) {
      return this.typeFichier(item.originalname);
    },

    retourSecond() {
      this.$emit("retourSecond")
    },

    retourThird() {
      this.flagFourth = false;
    },

    ouvrirModalDossier(type) {
      this.type = type;
      this.flagCreate = true;
    },

    ouvrirModalFichier(type) {
      this.type = type;
      this.flagCreate = true;
    },

    closeConfirmation() {
      this.type = null;
      this.flagCreate = false;
    },

    confirmerSuppression(item) {
      this.elementASupprimer = item;
      this.flagDeleteModel = true;
    },
    supprimerElement() {
      const { _id, originalname } = this.elementASupprimer;
      Espace.supprimer(_id, originalname, "third")
        .then(result => {
          if (result) {
            this.listeTableThird = this.listeTableThird.filter(el => el._id !== _id);
            this.flagDeleteModel = false;
            this.elementASupprimer = null;
          }
        })
        .catch(err => console.log(err));
    },
    async download(filename, value) {
      try {
        const response = await Espace.download(filename, value);
        if (response?.data?.url) {
          window.open(response.data.url, "_blank");
        } else {
          console.error("Lien de téléchargement introuvable");
        }
      } catch (error) {
        console.error("Erreur téléchargement :", error);
      }
    },
  },
created() {
  this.domain = this.email.split("@")[1];
  this.isLoading = true;
  Espace.readThird(this.idSecond)
    .then(res => {
       console.log(res)
      this.listeTableThird = res.data.listeTree;
      this.isLoading = false;
    })
    .catch(err => console.log(err));
}

};
</script>
<style scoped>
.table_component {
  overflow: auto;
  width: 100%;
  background-color: #fff;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0, 87, 227, 0.1);
  font-family: 'Cairo', 'Segoe UI', sans-serif;
}

/* Boutons du haut */
.table_component .buttons {
  display: flex;
  gap: 15px;
  padding: 10px 0 20px 0;
  flex-wrap: wrap;
}

.table_component .buttons button {
  color: white;
  padding: 8px 20px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 0.9rem;
  border: none;
  transition: transform 0.2s, background-position 0.4s ease;
  background-size: 200% auto;
}

/* Bouton Retour - bleu */
.table_component .buttons button:nth-child(1) {
  background: linear-gradient(90deg, #0057e3, #0041b3);
}

.table_component .buttons button:nth-child(1):hover {
  background-position: right center;
  transform: scale(1.05);
}

/* Bouton Téléverser - orange */
.table_component .buttons button:nth-child(2) {
  background: linear-gradient(90deg, #fd7e14, #e8590c);
}

.table_component .buttons button:nth-child(2):hover {
  background-position: right center;
  transform: scale(1.05);
}

/* Bouton Créer un dossier - vert */
.table_component .buttons button:nth-child(3) {
  background: linear-gradient(90deg, #28a745, #218838);
}

.table_component .buttons button:nth-child(3):hover {
  background-position: right center;
  transform: scale(1.05);
}

/* Tableau */
.table_component table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 87, 227, 0.1);
}

.table_component th,
.table_component td {
  padding: 12px 15px;
  text-align: left;
  font-size: 0.95rem;
}

.table_component th {
  background-color: #053075;
  color: #fff;
}

.table_component td {
  background-color: #f4f6f8;
  border-bottom: 1px solid #d1d1d1;
}

/* Actions boutons dans le tableau */
.table_component td.buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}

.telecharger,
.supprimer,
.apercu {
  color: white;
  padding: 6px 15px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 5px;
  border: none;
  transition: transform 0.2s;
}

.telecharger {
  background-color: #348334;
}

.telecharger:hover {
  background-color: #2c6f2c;
  transform: scale(1.05);
}

.supprimer {
  background-color: #dc3545; /* Rouge vif */
  color: white;
}

.supprimer:hover {
  background-color: #b52a37; /* Rouge plus foncé au hover */
  transform: scale(1.05);
}

.apercu {
  background-color: #0057e3;
}

.apercu:hover {
  background-color: #0041b3;
  transform: scale(1.05);
}

.fa {
  margin-right: 5px;
}
</style>